import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ToastMessageService } from 'src/app/toastr.service';
import { UserRegistrationService } from './user-registration.service';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss']
})
export class UserRegistrationComponent implements OnInit {
  formData = {
    company_name: '',
    full_name: '',
    email: '',
    currency: 'Indian Rupee', // Set default value for Currency
    period_returns: 5, // Set default value for Period of calculating returns
    tax_rate: 30, // Set default value for Tax Rate
    depreciation: 10, // Set default value for Depreciation
    sg_a: 10, // Set default value for SG&A
    logistics_insurance: 6, // Set default value for Logistic & Insurance
    market_share: 0, // Assuming no default value is provided for Market share
    amortisation: 5, // Set default value for Amortisation
    rebates_discount: 8, // Set default value for Rebate & Discount
    solid_oral_healthy: 20,
    solid_oral_patient: 20,
    injectables_waiver: 12,
    injectables_pk: 1,
    topical: 12,
    inhalation: 12,
    category: ''
  };
  userData: any;
  loading: boolean = true;
  email: any;
  sourceDropdownOptions = [];

  productOptions: { label: string; value: string }[] = [];
  selectedProducts: string[] = [];
  productsLoading: boolean = false;
  multiSelectFilter: string = '';
  private productSearchSubject = new Subject<string>();

  constructor(private toastService: ToastMessageService, private UserRegistrationService: UserRegistrationService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getUserRegisterData();
    this.getcompanyregister();
    this.initProductSearch();
  }

  submitForm() {
    console.log('Form submitted!', this.formData);

    const productsPayload = {
      products_data: this.selectedProducts
    };

    this.UserRegistrationService.userRegistrationForm(this.formData, this.email, productsPayload).subscribe((response) => {
      console.log("response", response);
      if (response['message'] === 'User registered successfully!') {
        this.toastService.success('User registered successfully!');
      } else if (response['message'] === 'Email already exists.') {
        this.toastService.error('Email already exists.');
      } else {
        this.toastService.error('Registration failed. Please try again later.');
      }
      this.getUserRegisterData();
    }, error => {
      console.error('Error occurred:', error);
      this.toastService.error('An error occurred. Please try again later.');
    });
    this.resetForm();
  }
  resetForm() {
    this.formData = {
      company_name: '',
      full_name: '',
      email: '',
      currency: 'Indian Rupee',
      period_returns: 5,
      tax_rate: 30,
      depreciation: 10,
      sg_a: 10,
      logistics_insurance: 6,
      market_share: 0,
      amortisation: 5,
      rebates_discount: 8,
      solid_oral_healthy: 20,
      solid_oral_patient: 20,
      injectables_waiver: 12,
      injectables_pk: 1,
      topical: 12,
      inhalation: 12,
      category: ''
    };
    this.selectedProducts = [];
  }

  getcompanyregister() {
    this.UserRegistrationService.companyDataUpdate().subscribe((response) => {
      if (response["data"]) {
        this.sourceDropdownOptions = [
          { label: 'Select Company', value: '' },  // first default option
          ...response["data"].map((item) => {
            return {
              label: item.company_name,
              value: item.company_name,
              ...item
            };
          })
        ];

      }
    })
  }
  dropdownchange(e) {
    this.formData.company_name = e.value
  }


  getUserRegisterData() {
    this.UserRegistrationService.userDataUpdate(this.email).subscribe((response) => {
      this.userData = response["data"];
      console.log("resss", this.userData);
      this.loading = false;
    });
  }

  editRow(rowData: any) {
    rowData.isEditing = true;
    rowData.originalEndDate = rowData.end_date; // Save the original value for cancel functionality
  }


  saveRow(rowData: any) {
    rowData.isEditing = false;

    // Ensure the end_date is in dd/mm/yyyy format before saving
    if (rowData.end_date) {
      rowData.end_date = rowData.end_date.toLocaleDateString('en-GB') // Format the end_date
    }
    console.log('Updated row:', rowData);
    const UserData = {
      email: rowData.email,
      company_name: rowData.company_name,
      end_date: rowData.end_date,
    };
    this.UserRegistrationService.UpdateSubscription(UserData).subscribe(
      (response) => {
        console.log('User data updated successfully:', response);
        this.toastService.success('User data updated successfully.');
        // Refresh user data after update
        this.getUserRegisterData();
        this.getcompanyregister();
      },
      (error) => {
        console.error('Error updating user data:', error);
        this.toastService.error('An error occurred while updating user data. Please try again later.');
      }
    );
  }

  cancelEdit(rowData: any) {
    rowData.isEditing = false;
    rowData.end_date = rowData.originalEndDate; // Revert to the original value
    delete rowData.originalEndDate;
  }

  onDateChange(event: any, rowData: any, rowIndex: number) {
    console.log('rowdataaa', rowData)
    const startDate = rowData['start_date'] // Parse the start_date
    const endDate = event.toLocaleDateString('en-GB')// Parse the new end_date
    console.log("start", startDate)
    console.log("end", endDate)
    if (startDate > endDate) {
      rowData.dateError = 'End date cannot be earlier than start date.';
      rowData.end_date = null; // Reset the end date if invalid
    } else {
      rowData.dateError = ''; // Clear the error
      rowData.end_date = event; // Update the date in the row data
    }

    console.log(`Date changed for row ${rowIndex}:`, rowData);
  }

  changeUserStatus(rowData: any, isActive: boolean) {
    const updatedUserData = { ...rowData, is_active: isActive };
    this.UserRegistrationService.postUserStatus(updatedUserData).subscribe(
      (response) => {
        console.log("User status updated successfully:", response);
        // Refresh user data after status update
        this.getUserRegisterData();
      },
      (error) => {
        console.error('Error updating user status:', error);
        this.toastService.error('An error occurred while updating user status. Please try again later.');
      }
    );
  }

  initProductSearch(): void {
    this.productSearchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((keyword: string) => {
      this.productsLoading = true;
      this.UserRegistrationService.getProducts(keyword).subscribe(
        (response) => {
          if (response?.data) {
            this.productOptions = response.data.map((item: string) => ({
              label: item,
              value: item
            }));
          }
          this.productsLoading = false;
        },
        (error) => {
          console.error('Error loading products:', error);
          this.productsLoading = false;
        }
      );
    });
  }

  onProductSearch(event: any): void {
    if (!event.filter || event.filter.trim().length < 2) {
      this.productOptions = [];
      return;
    }

    this.productSearchSubject.next(event.filter);
  }

  onProductSelectionChange(event: any): void {
    this.selectedProducts = event.value ?? [];
  }

  removeProduct(product: string): void {
    this.selectedProducts = this.selectedProducts.filter(p => p !== product);
  }
}
// if (response['message'] === 'User registered successfully!') {
//   this.toastService.success('User Registered successfully!');
// } else if (response['message'] === 'Email already exists.') {
//   this.toastService.error('Email already exists.');
// } else {
//   this.toastService.error('Registration failed. Please try again later.');
// }